import Cookies from 'js-cookie';

export const COOKIE_COMPLIANCE_CONSENT = 'COOKIE_COMPLIANCE_CONSENT';
export function cookieComplianceConsent(
  didConsent,
  cookieSettings = {
    cookieExpiration: 365,
    cookieDomain: null,
    path: null,
  }
) {
  const { cookieExpiration, cookieDomain, path } = cookieSettings;
  Cookies.set('cookie-compliance-consent', didConsent, {
    expires: cookieExpiration,
    domain: cookieDomain,
    path: path,
  });
  return {
    type: COOKIE_COMPLIANCE_CONSENT,
    didConsent,
  };
}
